var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBridgeDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    rx: 6,
    fill: "#777E90"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8999 14.8V8.15C17.8999 7.38 17.2699 6.75 16.4999 6.75H12.6499",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8999 19.75C19.2806 19.75 20.3999 18.6307 20.3999 17.25C20.3999 15.8693 19.2806 14.75 17.8999 14.75C16.5192 14.75 15.3999 15.8693 15.3999 17.25C15.3999 18.6307 16.5192 19.75 17.8999 19.75Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1001 9.19995V15.85C7.1001 16.62 7.7301 17.25 8.5001 17.25H12.3501",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1001 9.25C8.48081 9.25 9.6001 8.13071 9.6001 6.75C9.6001 5.36929 8.48081 4.25 7.1001 4.25C5.71939 4.25 4.6001 5.36929 4.6001 6.75C4.6001 8.13071 5.71939 9.25 7.1001 9.25Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4581 8.50281V4.98418C14.4581 4.51393 13.9135 4.25309 13.5471 4.54783L11.3794 6.29143C11.1023 6.51434 11.1004 6.93574 11.3756 7.16106L13.5433 8.93608C13.9089 9.23546 14.4581 8.97535 14.4581 8.50281Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5413 18.9193V15.5667C10.5413 15.0629 11.1248 14.7834 11.5174 15.0992L13.5828 16.7605C13.8797 16.9994 13.8817 17.4509 13.5869 17.6923L11.5215 19.3836C11.1297 19.7043 10.5413 19.4256 10.5413 18.9193Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBridgeDefault);
export default __webpack_public_path__ + "static/media/bridge_default.3c85640bc1df8a556d964d0497dd67e8.svg";
export { ForwardRef as ReactComponent };